module.exports = __webpack_public_path__ + "public/img/xian.b3000558.png";